<template>
  <b-col :xl="content.columns" cols="12">
    <div class="card bg-primary">
      <LmComponentLoading v-if="loading" />
      <div class="card-body">
        <!-- <div class="dropdown float-right">
          <a href="#" class="dropdown-toggle text-white arrow-none card-drop" data-toggle="dropdown" aria-expanded="false">
            <i class="mdi mdi-dots-vertical"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item">Sales Report</a>
            <a class="dropdown-item">Export Report</a>
            <a class="dropdown-item">Profit</a>
            <a class="dropdown-item">Action</a>
          </div>
        </div> -->
        <h4 class="header-title text-white mb-4">{{ content.title }}</h4>
        <div class="text-center">
          <p class="mt-4 mb-2">
            <span class="badge badge-danger">{{ content.percentage }}</span>
          </p>
          <h3 class="font-weight-normal text-white mb-2">{{ content.money }}</h3>
          <p class="text-light text-uppercase font-13 font-weight-bold">{{ content.text }}</p>
          <router-link :to="content.link" class="btn btn-outline-light btn-sm mb-1">More
            <i class="mdi mdi-arrow-right ml-1"></i>
          </router-link>

        </div> <!-- end card-body-->
      </div> <!-- end card-->
    </div> <!-- end col-->
  </b-col>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['content'],
  computed: {
    ...mapState('settings', ['loading'])
  }
}
</script>
